export const testDestinationConnectionAction =
  'testDestinationConnectionAction';
export const testExistingDestinationConnectionAction =
  'testExistingDestinationConnectionAction';
export const changeDestinationStatusAction = 'changeDestinationStatusAction';
